import Authorization from "../../../../generics/authorization";
import App360 from ".";

const pageProps = {
  workflowContainer: true,
  dashlets: [{
    component: App360,
    name: "SingleApplicationSummary",
    layout: { x: 0, y: 0, w: 100, h: 40 }
  }]
};

const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
